// A test URL never sends mutations to production DataDoc, media or game routes.
export function testApi(realApi, {enabled,actionId,orgId}) {
 if(!enabled)return realApi;
 const root=`/public/actions/${encodeURIComponent(actionId)}/test`;
 return async(path,options={})=>{
  let endpoint;
  if(path.startsWith('/public/actions/'))endpoint=root;
  else if(path==='/datadoc/adddatadoc')endpoint=root+'/document';
  else if(path==='/media/public-upload-url')endpoint=root+'/upload';
  else if(path==='/datadoc/attach-media')endpoint=root+'/attach';
  else if(path==='/datadoc/lock'||path==='/datadoc/finalize')endpoint=root+'/submit';
  else if(/^\/cards\/public\/[a-f0-9]{24}$/i.test(path))endpoint=path; // existing public read-only card composition
  else throw new Error('This operation is unavailable in Landing Page test mode.');
  const result=await realApi(endpoint,{...options,orgIdOverride:orgId,retryAuth:false});
  if(endpoint===root && result?.testMode!==true)throw new Error('Landing Page test mode was not verified by the server.');
  return result;
 };
}
